import { findAll, find } from './find';

function initializePaypalButton() {
    const form = document.querySelector('.js-paypal-form');
    const maps = document.querySelector('.maps');

    function redirectToPaypal(e) {
        function addParamToQuery(input) {
            query.push(input.name + '=' + input.value);
        }
        e.preventDefault();
        const query = [];
        const hiddenInputs = findAll('input[type=\'hidden\']', form);
        hiddenInputs.map(addParamToQuery);
        const queryStr = '/search?' + query.join('&');
        window.location.href = form.getAttribute('action') + queryStr;
    }

    function setIframePointerEventsToAuto() {
        find('iframe', maps).style.pointerEvents = 'auto';
    }

    function setIframePointerEventsToNone() {
        find('iframe', maps).style.pointerEvents = 'none';
    }

    if (form) {
        form.addEventListener('click', redirectToPaypal, false);
    }

    if (maps) {
        maps.addEventListener('click', setIframePointerEventsToAuto, false);
        maps.addEventListener('mouseleave', setIframePointerEventsToNone, false);
    }
}

module.exports = initializePaypalButton;



// WEBPACK FOOTER //
// ./src/js/paypal_button.js